export default __webpack_public_path__ + "static/media/napojovekartony.db17cf8f.svg";